import PropTypes from '../../../utils/propTypes';
import DoubleBar from '../DoubleBar';

export const ConcreteWidget = ({ table, values }) => {
  return <DoubleBar table={table} values={values} />;
};

ConcreteWidget.propTypes = {
  table: PropTypes.element.isRequired,
  values: PropTypes.object.isRequired,
};
